import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export class SingleImageOptions extends LayoutRenderLayoutItemOptions {
	filter?: SingleImageFilter[];
	photosInData: boolean;

	constructor() {
		super();
		this.photosInData = false;
	}
}

export class SingleImageFilter {
	key: string;
	value: string;
}